require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./transition-gymnase-2-0-5.json") })
        }
      }, "path---transition-gymnase-2-0-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---transition-gymnase-2-0-5!./.cache/json/transition-gymnase-2-0-5.json
// module id = 594
// module chunks = 231608221292675